export type FieldErrors = Record<string, string>;

export class AppError extends Error {
  code?: string;
  statusCode?: number;
  details?: unknown;
  fieldErrors?: FieldErrors;

  constructor(
    message: string,
    code?: string,
    statusCode?: number,
    options: { details?: unknown; fieldErrors?: FieldErrors } = {}
  ) {
    super(message);
    this.code = code;
    this.statusCode = statusCode;
    this.details = options.details;
    this.fieldErrors = options.fieldErrors;
  }
}
